import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import * as serviceWorker from './serviceWorker';
import './styles.scss';
import '@dew21/ui/dist/dew-icons.css';
import { RecoilRoot } from 'recoil';
import { UserState, SessionState, AuthStore, initAxios } from '@dew21/ui';
import { STORAGE_KEY_DEW_SESSION } from './utils/Keys';
import { CommonStoreHandler } from './store/CommonStoreHandler';
import axios from 'axios';

// init auth store
AuthStore.use(CommonStoreHandler, STORAGE_KEY_DEW_SESSION);

// init axios
initAxios();

axios.interceptors.request.use((config) => {
  config.headers = { ...AuthStore.getAuthHeader()?.headers, ...config.headers };     // add auth header
  // config.headers['Content-Type'] = 'application/json';
  return config;
});

const initializeState = ({ set }: any) => {
  const session = AuthStore.getSession();
  if (session) {
    const { tokens, ...user } = session;

    set(SessionState, { current: { tokens } });
    set(UserState, { current: user });
  }
};

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot initializeState={initializeState}>
      <App/>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('dew-web-app'),
);

serviceWorker.unregister();
